module.exports = __webpack_public_path__ + "static/efficience-290d0e99f8a16e5baa34b97d926910ac.png";